<header>
    <span>Active Legends</span>
</header>

<div class="legend-container" *ngFor="let item of legendList">
    <p class="legend-layer-name">{{ item.name }}</p>
    <eaglei-legend [legends]="item.legends"></eaglei-legend>
</div>
